export default class ApplicationTab {
	constructor(data?: any) {
		if (data) {
			this.id = data.id;
			this.name = data.name;
			this.view = data.view;
			this.allowMultiple = data.allowMultiple;
			this.params = data.params;			
		}
	}

	id: number = 0;
	name: string | null = null;
	view: string | null = null;		
	allowMultiple = false;
	params: Array<any> | null = null;
}